import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss"; // SCSS styles
import { whyChooseData } from "../../assets/config/config";

export default function WhyChooseUs() {
    return (
        <section className={styles.whyChooseSection}>
            <div className={styles.container}>
                {/* Left Side - Images */}
                <div className={styles.imageContainer}>
                    <img src={whyChooseData.images.main} alt="Electrician" className={styles.mainImage} />
                    {/* <img src={whyChooseData.images.secondary} alt="Working" className={styles.secondaryImage} /> */}
                </div>

                {/* Right Side - Content */}
                <div className={styles.contentContainer}>
                    <span className={styles.subtitle}>{whyChooseData.subtitle}</span>
                    <h2 className={styles.title}>{whyChooseData.title}</h2>
                    <p className={styles.description}>{whyChooseData.description}</p>

                    {/* Features List */}
                    <div className={styles.featuresList}>
                        {whyChooseData.features.map((feature, index) => (
                            <div key={index} className={styles.featureItem}>
                                <div className={styles.icons}>
                                    <img src={feature.icon} alt={feature.title} className={styles.featureIcon} />
                                </div>
                                <div>
                                    <h4 className={styles.featureTitle}>{feature.title}</h4>
                                    <p className={styles.featureDescription}>{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
